const RESET_PASSWORD_SUCCESS = 'authentication.password-reset-success';
const ERROR_SENDING_VERIFICATION_CODE = 'authentication.verification-code-send-error';
const VERIFICATION_CODE_VERIFIED = 'authentication.verify-code-success';
const RESET_PASSWORD_ERROR = 'authentication.password-reset-error';
const VERIFICATION_ERROR = 'authentication.verify-code-error';
const VERIFICATION_CODE_SENT = 'authentication.verification-code-send-success';

export class VerifyCodeController {
    /* @ngInject */
    constructor(passwordCredentialsService, $log, contactPointService, $state, $stateParams,
                $translate, userSession, uuid, email, toastr, deviceTokenService) {
        this.passwordCredentialsService = passwordCredentialsService;
        this.contactPointService = contactPointService;
        this.$state = $state;
        this.$log = $log;
        this.$translate = $translate;
        this.resetResponse = null;
        this.verificationForm = {};
        this.userSession = userSession;
        this.userDetails = this.userSession[0];
        this.userDetails.deviceTokenUuid = this.uuid;
        this.email = email;
        this.uuid = uuid;
        this.deviceTokenService = deviceTokenService;
        this.toastr = toastr;
        this.checkState();
        this.toastr.options = {
            "showDuration": "6000"
        };
    }

    checkState() {
        if (this.email) {
            this.getVerificationCode();
        }
    }

    getVerificationCode() {
        this.contactPointService.requestVerificationCodeByType(this.uuid, this.userDetails.username)
            .then(response => {
                this._translateMessage('SUCCESS', VERIFICATION_CODE_SENT);
                this.resetResponse = response;
            }, response => {
                this._translateMessage('Error', ERROR_SENDING_VERIFICATION_CODE);
                this.handleError(response);
            });
    }

    attemptVerification() {
        this.contactPointService.sendVerificationCodeByType(this.userDetails, this.verificationForm.code)
            .then(response => {
                this._translateMessage('Success', VERIFICATION_CODE_VERIFIED);
                this._handleSuccess(response);
            }, response => {
                this._translateMessage('Error', VERIFICATION_ERROR);
                this._handleError(response);
            });
    }

    handleSubmit() {
        if (this.email) {
            this.attemptVerification();
            return true;
        }
        return false;
    }

    _handleSuccess() {
        this.$state.go('flow');
    }

    _handleError(response) {
        this.resetResponse = response;
        this.email = null;
    }

    _translateMessage(type, messageCode) {
        this.$translate(messageCode).then(translation => {
            if (type.toUpperCase() === 'ERROR') {
                this.toastr.error(translation, type);
            }
            if (type.toUpperCase() === 'SUCCESS') {
                this.toastr.success(translation, type);
            }
        });
    }
}
